var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5L16.29 2.79L11.41 7.67L7.41 3.67L0 11.09L1.41 12.5L7.41 6.5L11.41 10.5L17.71 4.21L20 6.5V0.5H14Z",
    fill: "#1CB783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveTrend);
export default __webpack_public_path__ + "static/media/positive_trend.91561c15f434c0589eb1012d83e5a2f5.svg";
export { ForwardRef as ReactComponent };